<template>
    <vx-card
        class="card mt-2 cursor-pointer pb-0 widget-group-item"
        card-border
        :title="categoryName"
        :subtitle="subtitle"
        @click.native.prevent.stop="openSubgroup"
    >
        <template slot="actions">
            <vx-basic-icon icon="ChevronRightIcon" size="6" />
        </template>
        <widget-group
            :categoryName="categoryName"
            v-bind="$attrs"
            v-on="$listeners"
            :widgets="widgets"
            :open.sync="localOpen"
        />
    </vx-card>
</template>

<script>
export default {
    name: 'widget-group-item',
    components: {
        WidgetPreview: () => import('./WidgetPreview.vue'),
        WidgetGroup: () => import('./WidgetGroup.vue')
    },
    props: {
        categoryName: {
            type: String
        },
        widgets: {
            type: Array,
            default: () => []
        },
        open: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localOpen: false
        }
    },
    watch: {},
    computed: {
        subtitle() {
            return `Contains ${this.widgets.length} Items`
        }
    },
    methods: {
        openSubgroup() {
            this.localOpen = true
        },
        onDragStart(e) {
            this.localOpen = false
            this.$emit('dragstart', e)
        },
        onDragEnd(e) {
            this.localOpen = true
            this.$emit('dragend', e)
        }
    }
}
</script>

<style lang="scss" scoped>
.widget-group-item {
    &:hover {
        background: linear-gradient(
            90deg,
            rgba(var(--vs-primary), 0.6) 0%,
            rgba(var(--vs-primary), 0.35) 49%,
            rgba(var(--vs-primary), 0.15) 100%
        );
    }
}

.vx-card {
    ::v-deep .vx-card__header {
        padding-bottom: 0px;
    }
}
</style>
